var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { enrollmentApiRequest } from "./client";
import {
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
import { ENROLLMENT_API_URL } from "../config/app-config";
import { setAuthHeaders } from "../create-api-client";
var AttemptStatus = /* @__PURE__ */ ((AttemptStatus2) => {
  AttemptStatus2["ASSIGNED"] = "ASSIGNED";
  AttemptStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  AttemptStatus2["SUBMITTED"] = "SUBMITTED";
  AttemptStatus2["COMPLETED"] = "COMPLETED";
  AttemptStatus2["LOCKED"] = "LOCKED";
  AttemptStatus2["RESET"] = "RESET";
  AttemptStatus2["PAUSED"] = "PAUSED";
  return AttemptStatus2;
})(AttemptStatus || {});
const fetchAttempts = (enrollmentId, activityId) => {
  return enrollmentApiRequest({
    url: `enrollment-attempt`,
    method: "GET",
    params: { enrollmentId, activityId }
  });
};
const fetchAttemptsByStudent = (studentId) => {
  return enrollmentApiRequest({
    url: `/enrollment-attempt`,
    method: "GET",
    params: { studentId }
  });
};
const fetchAttempt = (attemptId) => {
  return enrollmentApiRequest({
    url: `enrollment-attempt/${attemptId}`,
    method: "GET"
  });
};
function lockAttempt(enrollmentAttemptId) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/${enrollmentAttemptId}/lock`,
    method: "PATCH"
  });
}
function unlockAttempt(enrollmentAttemptId) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/${enrollmentAttemptId}/unlock`,
    method: "PATCH"
  });
}
function patchAttemptKeepAlive(body) {
  const headers = {
    "Content-Type": "application/json"
  };
  setAuthHeaders(headers);
  return fetch(
    `${ENROLLMENT_API_URL}/enrollment-attempt/${body.enrollmentAttemptId}`,
    {
      method: "PATCH",
      keepalive: true,
      body: JSON.stringify(body),
      headers
    }
  );
}
function recordSubmitTakeFailure(failure, attemptId) {
  const headers = {
    "Content-Type": "application/json"
  };
  setAuthHeaders(headers);
  return fetch(
    `${ENROLLMENT_API_URL}/enrollment-attempt/${attemptId}/submit-failure`,
    {
      method: "POST",
      body: JSON.stringify(failure),
      headers
    }
  );
}
function launchAttempt(enrollmentId, activityId) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/launch`,
    method: "POST",
    params: { enrollmentId, activityId }
  });
}
function postAttempt(attempt) {
  return enrollmentApiRequest({
    url: `enrollment-attempt`,
    method: "POST",
    data: attempt
  });
}
function postNextAttempt(enrollmentId) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/next-attempt/${enrollmentId}`,
    method: "POST"
  });
}
function patchMarkSegmentsForReview(enrollmentAttemptId, type, segmentId) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/${enrollmentAttemptId}/review/${type}/${segmentId}`,
    method: "PATCH"
  });
}
function useAttemptsQuery(enrollmentId, activityId, options) {
  return useQuery(
    ["attempts", enrollmentId, activityId],
    () => __async(this, null, function* () {
      const attempts = yield fetchAttempts(enrollmentId, activityId);
      if (attempts) {
        return attempts.slice().sort(
          (attempt1, attempt2) => {
            var _a, _b;
            return Date.parse((_a = attempt1 == null ? void 0 : attempt1.audit) == null ? void 0 : _a.createdAt) - Date.parse((_b = attempt2 == null ? void 0 : attempt2.audit) == null ? void 0 : _b.createdAt);
          }
        );
      }
      return [];
    }),
    __spreadProps(__spreadValues({}, options), {
      cacheTime: 0
    })
  );
}
function useAttemptsByStudentQuery(studentId) {
  return useQuery(
    ["attempts", studentId],
    () => fetchAttemptsByStudent(studentId),
    {
      cacheTime: 0
    }
  );
}
function useAttemptQuery(attemptId, options) {
  return useQuery(
    ["attempt", attemptId],
    () => fetchAttempt(attemptId),
    options
  );
}
function useAttemptCreateMutation() {
  return useMutation(
    ({ enrollmentId, activityId, status }) => postAttempt({
      enrollmentId,
      activityId,
      status
    }),
    { useErrorBoundary: true }
  );
}
function useAttemptLaunchMutation() {
  return useMutation(
    ({ enrollmentId, activityId }) => launchAttempt(enrollmentId, activityId),
    { useErrorBoundary: true }
  );
}
function useAttemptUnlockMutation() {
  return useMutation(
    (enrollmentAttemptId) => unlockAttempt(enrollmentAttemptId),
    {
      useErrorBoundary: true
    }
  );
}
function useAttemptLockMutation() {
  return useMutation(
    (enrollmentAttemptId) => lockAttempt(enrollmentAttemptId),
    {
      useErrorBoundary: true
    }
  );
}
function useCreateNextAttemptMutation() {
  return useMutation(
    "createNextAttempt",
    (enrollmentId) => postNextAttempt(enrollmentId),
    {
      useErrorBoundary: false
    }
  );
}
function useCreateNextAttemptQuery(enrollmentId) {
  return useQuery(
    ["createNextAttempt", enrollmentId],
    () => postNextAttempt(enrollmentId),
    {
      useErrorBoundary: false
    }
  );
}
function useCreateAttemptQuery(enrollmentId, activityId, status) {
  return useQuery(
    ["createAttempt", enrollmentId],
    () => postAttempt({
      enrollmentId,
      activityId,
      status
    }),
    {
      useErrorBoundary: false
    }
  );
}
function useAttemptLaunchQuery(enrollmentId, activityId) {
  return useQuery(
    ["launchAttempt", enrollmentId],
    () => launchAttempt(enrollmentId, activityId),
    {
      useErrorBoundary: false
    }
  );
}
function useAttemptPatchSegmentsForReviewMutation() {
  const queryClient = useQueryClient();
  return useMutation(
    "patchMarkSegmentsForReview",
    ({ enrollmentAttemptId, type, segmentId }) => patchMarkSegmentsForReview(enrollmentAttemptId, type, segmentId),
    {
      useErrorBoundary: true,
      onSuccess(data) {
        if (data) {
          queryClient.setQueryData(["attempt", data.enrollmentAttemptId], data);
        }
      }
    }
  );
}
function saveAndExitPatchAttemptWithSession(attemptId, finalizeAttemptSessionRequest) {
  const headers = {
    "X-API-VERSION": "2"
  };
  return enrollmentApiRequest({
    url: `enrollment-attempt/${attemptId}/saveAndExit`,
    method: "PATCH",
    data: finalizeAttemptSessionRequest,
    headers
  });
}
function saveAndExitPatchAttemptWithSessionKeepAlive(attemptId, finalizeAttemptSessionRequest) {
  const headers = {
    "Content-Type": "application/json",
    "X-API-VERSION": "2"
  };
  setAuthHeaders(headers);
  return fetch(
    `${ENROLLMENT_API_URL}/enrollment-attempt/${attemptId}/saveAndExit`,
    {
      method: "PATCH",
      keepalive: true,
      body: JSON.stringify(finalizeAttemptSessionRequest),
      headers
    }
  );
}
function useSaveAndExitAttemptWithSessionPatchMutation() {
  return useMutation(
    "saveAndExitAttemptWithSessionPatchMutation",
    ({ attemptId, finalizeAttemptSessionRequest }) => saveAndExitPatchAttemptWithSession(
      attemptId,
      finalizeAttemptSessionRequest
    ),
    { useErrorBoundary: true }
  );
}
function submitAttempt(attemptId, submitAttemptRequestWithSession, autoSubmit = false, outOfSync = false) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/${attemptId}/submit?autoSubmit=${autoSubmit}&outOfSync=${outOfSync}`,
    method: "PATCH",
    data: submitAttemptRequestWithSession
  });
}
function useSubmitAttemptWithSessionMutation() {
  return useMutation(
    "",
    ({ attemptId, submitAttemptRequestWithSession, autoSubmit, outOfSync }) => submitAttempt(
      attemptId,
      submitAttemptRequestWithSession,
      autoSubmit,
      outOfSync
    ),
    { useErrorBoundary: true }
  );
}
export {
  AttemptStatus,
  fetchAttempt,
  lockAttempt,
  patchAttemptKeepAlive,
  patchMarkSegmentsForReview,
  postNextAttempt,
  recordSubmitTakeFailure,
  saveAndExitPatchAttemptWithSession,
  saveAndExitPatchAttemptWithSessionKeepAlive,
  submitAttempt,
  unlockAttempt,
  useAttemptCreateMutation,
  useAttemptLaunchMutation,
  useAttemptLaunchQuery,
  useAttemptLockMutation,
  useAttemptPatchSegmentsForReviewMutation,
  useAttemptQuery,
  useAttemptUnlockMutation,
  useAttemptsByStudentQuery,
  useAttemptsQuery,
  useCreateAttemptQuery,
  useCreateNextAttemptMutation,
  useCreateNextAttemptQuery,
  useSaveAndExitAttemptWithSessionPatchMutation,
  useSubmitAttemptWithSessionMutation
};
